<template>
  <v-row justify="center">
    <v-dialog
      v-model="shower"
      scrollable
      persistent
      max-width="600px"
      v-if="resolutionScreen >= 500"
    >
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template> -->

      <v-card>
        <v-card-title
          >{{ $t("mainRClick.createfile") + ' ' + ':' + ' '}} {{document_text}} {{'(' + '.' + (file_type) + ')'}} <v-spacer></v-spacer>
          <v-icon v-if="file_type === 'docx'" color="#0263d1" dark size="35">mdi-file-word</v-icon>
          <v-icon v-else-if="file_type === 'xlsx'" color="#00733b" dark size="35">mdi-file-excel</v-icon>
          <v-icon v-else-if="file_type === 'pptx'" color="#e03303" dark size="35">mdi-file-powerpoint</v-icon>
          <v-icon v-else-if="file_type === 'txt'" color="blue-grey" dark size="35">mdi-file-document</v-icon>
        </v-card-title>
        <v-divider></v-divider>

        <!-- ***** hashtag ****** -->
        <!-- <v-card-text>
          <v-checkbox v-model="checkhashtag" label="Hashtag"></v-checkbox>
          <v-row v-if="checkhashtag === true">
            <v-col cols="9" sm="10" xs="9">
              <v-text-field
                v-model="hashtag"
                label="#hashtag"
                dense
                outlined
                :error-messages="hashtagErrors"
                @input="$v.hashtag.$touch()"
                @blur="$v.hashtag.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="3" sm="2" xs="3" class="pt-3">
              <v-btn 
                class="white--text" 
                :color="color.theme" 
                @click="addhashtag(), $v.hashtag.$reset()" 
                :disabled="hashtagErrors.length > 0 ? true : false || hashtag.length === 0"
              >
                {{ $t("edithashtag.add") }}</v-btn
              >
            </v-col>
            <v-col cols="12">
              <v-chip
                v-for="(item, index) in datahashtag"
                :key="index"
                close
                class="ma-1"
                @click:close="deletehashtag(index)"
                >#{{ item }}</v-chip
              >
            </v-col>
          </v-row>
        </v-card-text> -->
        <v-card-text>
          <v-checkbox v-model="checkopenfile" :disabled="createprogress" :label="$t('mainRClick.open_file_when_complete')"></v-checkbox>
          <!-- <br /> -->
          <!-- $t('default') === 'th' -->
          <v-text-field
            :prepend-icon="file_type === 'docx' ? 'mdi-file-word' : file_type === 'xlsx' ? 'mdi-file-excel' : file_type === 'pptx' ? 'mdi-file-powerpoint' : 'mdi-file-document'"
            dense
            outlined
            :label="$t('default') === 'th' ? 'ชื่อไฟล์' : 'File Name'"
            v-model="filename"
            :value="filename"
            ref="input"
            :disabled="createprogress"
            :error-messages="filenameErrors"
            required
            :rules="[rules.noSpecialChar]"
            @input="$v.filename.$touch()"
            @blur="$v.filename.$touch()"
          ></v-text-field>
        </v-card-text>
        <!-- <v-card-text>
          <img
              src="@/assets/img/logo_file_word.png"
              width="150px"
              height="150px"
            />
        </v-card-text> -->
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="createprogress" color="error" outlined @click="$emit('close'), cleardata(), $emit('opendragselect')">{{
            $t("uploadfolder.buttonclose")
          }}</v-btn>
          <v-btn
            class="white--text"
            :color="color.theme"
            :loading="createprogress"
            :disabled="!this.fn_checkSpecialChar()"
            @click="createfile()"
            >{{ $t("mainRClick.createfile") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- หน้าจอมือถือ -->
    <v-dialog
      v-model="shower"
      scrollable
      persistent
      :max-width="maxWidthOnMobile"
      content-class="rounded-lg"
      v-else
    >
      <v-card>
        <v-card-text class="pa-5">
          <v-layout class="pt-2 pb-1">
            <v-flex d-flex justify-center class="ml-8">
              <span :style="headerPage">{{ $t("mainRClick.createfile") }}</span>
            </v-flex>
            <v-flex xs1 d-flex justify-end>
              <v-icon
                :color="$vuetify.theme.dark ? 'white' : color.theme"
                @click="$emit('close'), cleardata()"
                >mdi-close</v-icon
              >
            </v-flex>
          </v-layout>
          <!-- hashtag -->
          <!-- <v-checkbox v-model="checkhashtag" label="Hashtag"></v-checkbox>
          <v-row v-if="checkhashtag === true">
            <v-col cols="9" sm="10" xs="9">
              <v-text-field
                v-model="hashtag"
                label="#hashtag"
                dense
                outlined
                class="hastaghClass"
                height="35px"
                :error-messages="hashtagErrors"
                @input="$v.hashtag.$touch()"
                @blur="$v.hashtag.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="ml-n3 pt-3">
              <v-btn
                class="white--text"
                :color="color.theme"
                height="35px"
                @click="addhashtag(), $v.hashtag.$reset()"
                :disabled="hashtagErrors.length > 0 ? true : false || hashtag.length === 0"
              >
                {{ $t("edithashtag.add") }}</v-btn
              >
            </v-col>
            <v-col cols="12">
              <v-chip
                v-for="(item, index) in datahashtag"
                :key="index"
                close
                class="ma-1"
                @click:close="deletehashtag(index)"
                >#{{ item }}</v-chip
              >
            </v-col>
          </v-row> -->
          <v-checkbox v-model="checkopenfile" :disabled="createprogress" :label="$t('mainRClick.open_file_when_complete')"></v-checkbox>
          <span :style="titleText">{{
            $t('default') === 'th' ? 'ชื่อไฟล์' : 'File Name'
          }}</span>
          <v-text-field
            height="35px"
            class="mt-1 textFieldClass"
            dense
            outlined
            v-model="filename"
            ref="input"
            :disabled="createprogress"
            :error-messages="filenameErrors"
            required
            :rules="[rules.noSpecialChar]"
            @input="$v.filename.$touch()"
            @blur="$v.filename.$touch()"
          ></v-text-field>
        </v-card-text>
        <div class="text-center pb-4 mt-n2">
          <v-btn
            :style="btnAction"
            class="mr-6"
            height="40px"
            width="40%"
            color="red"
            outlined
            :disabled="createprogress"
            @click="$emit('close'), cleardata()"
            >{{ $t("uploadfolder.buttonclose") }}</v-btn
          >
          <v-btn
            :loading="createprogress"
            height="40px"
            class="elevation-0"
            :style="btnAction"
            width="40%"
            :color="color.theme"
            dark
            @click="createfile()"
            >{{ $t("mainRClick.createfile") }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
import { fil } from 'date-fns/locale';

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  mixins: [validationMixin],
  validations: {
    filename: { required },
    foldername: { required },
    hashtag: { required },
  },
  props: ["show", "parentfolder", "departmentid", "file_type", "document_text", "document_type"],
  data: function() {
    return {
      file_detail: [],
      checkopenfile: false,
      filename: '',
      listhashtag: [],
      foldername: "",
      createprogress: false,
      hashtag: "",
      datahashtag: [],
      checkhashtag: false,
      rules: {
        noSpecialChar: () =>
          this.fn_checkSpecialChar() ||
          // "A folder name cannot contain any of the following characters: \ / < > : ? * |",
          this.$t("uploadfolder.nospecialcharacter")
      },
      payloadfolder: {}
    };
  },
  computed: {
    ...mapState(["username", "authorize", "account_active", "color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
    ]),
    shower: {
      get() {
        if (this.show === true) {
          if(this.document_type === 'word'){
            this.filename = 'New Microsoft Word Document'
          }else if (this.document_type === 'excel'){
            this.filename = 'New Microsoft Excel Worksheet'
          }else if (this.document_type === 'powerpoint'){
            this.filename = 'New Microsoft PowerPoint Presentation'
          }else if (this.document_type === 'text') {
            this.filename = 'New Text Document'
          }
          // let inputEl = this.$refs.input.$el.querySelector('input')
          //   this.input = 'test value'
          //   inputEl.select()
          setTimeout(()=>{
           let inputEl = this.$refs["input"].$el.querySelector('input')
           inputEl.select()
                // console.log("this.$refs.input",this.$refs["input"].$el.querySelector('input'));
            },200)
          this.$emit("closeDrag");
          this.checkopenfile = false
        }
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    filenameErrors() {
      const errors = [];
      if (!this.$v.filename.$dirty) return errors;
      !this.$v.filename.required && errors.push(this.$t("กรุณากรอกชื่อไฟล์"));
      return errors;
    },
    foldernameErrors() {
      const errors = [];
      if (!this.$v.foldername.$dirty) return errors;
      !this.$v.foldername.required && errors.push(this.$t("กรุณากรอกชื่อไฟล์"));
      return errors;
    },
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
    headerPage() {
      return (
        "color:" +
        this.color.theme +
        ";" +
        "font-size: 16px; font-weight: 600; font-weight: bold; letter-spacing: 0px;"
      );
    },
    titleText() {
      return "color:black; font-size: 14px; line-height: 24px;";
    },
    btnAction() {
      return "font-size: 16px; font-weight: lighter;";
    },
    // ความกว้างของ dialog ของ ipad และ mobile
    maxWidthOnMobile() {
      if (this.resolutionScreen >= 400) {
        return 600;
      } else {
        return 346;
      }
    },
    hashtagErrors() {
      let errors = [];
      if (this.$v.hashtag.$dirty === false) {
        return errors;
      } else if (this.$v.hashtag.required === false) {
        errors.push(this.$t("edithashtag.hashtagempty"));
        return errors;
      } else {
        let allow = true;
        let specialChar = [",", " ", "|"];

        for (let index = 0; index < specialChar.length; index++) {
          const element = specialChar[index];
          if (this.hashtag.includes(element)) {
            allow = false;
            break;
          } else {
            continue;
          }
        }
        if (allow === false) {
          errors.push(this.$t("edithashtag.nospecialcharacter"));
          return errors;
        } else {
          return errors;
        }
      }
    },
  },
  methods: {
    addhashtag() {
      this.datahashtag.push(this.hashtag);
      console.log("this.datahashtag", this.datahashtag);
      this.hashtag = "";
    },
    deletehashtag(index) {
      this.datahashtag.splice(index, 1);
      console.log("this.datahashtag", this.datahashtag);
    },
    fn_checkSpecialChar() {
      let allow = true;
      let specialChar = ["<", ">", ":", "*", "?", "\\", "|", "/", '"'];

      for (let index = 0; index < specialChar.length; index++) {
        const element = specialChar[index];
        if (this.filename.includes(element)) {
          allow = false;
          break;
        }
      }
      // console.log("allow", allow);
      return allow;
    },
    async createfile() {
      console.log("Create File", this.filename);
      this.$v.$touch();
      if (!this.$v.filename.$invalid) {
        this.createprogress = true;
      let allowCreateFile = this.fn_checkSpecialChar();
      if (allowCreateFile) {
      let payload = {
        folder_id: this.parentfolder,
        filename: this.filename,
        data_type:this.file_type,
        account_id: this.dataAccountId,
      };
      console.log("payload",payload);
      let auth = await gbfGenerate.generateToken();
      console.log("auth",auth);
      await this.axios
        .post( process.env.VUE_APP_SERVICE_UPLOAD_API + "/api/v1/create/file_office", payload, {
          headers: { Authorization: auth.code },}
        )
        .then((response) => {
          console.log("response",response);
          if (response.data.status == "OK") {
              console.log("ok");
             Toast.fire({
              icon: "success",
              title: this.$t("mainRClick.createfile_complete"),
            });
            // this.$emit('close');
            this.$emit("closeandreload");
            this.createprogress = false;
            if(this.checkopenfile === true){
            let file_data = response.data.data
            this.$emit("file_detail",file_data)
            }
          } 
          else {
            Toast.fire({
              icon: "error",
              title: this.$t("mainRClick.createfile_failed"),
            });
            this.createprogress = false;
          }
        })
        .catch((err) => {
          console.log(err);
          Toast.fire({
            icon: "error",
            title: this.$t("toast.cannotconnectonebox"),
          });
          this.createprogress = false;
        });
      }
      }
    },
    async createfolder() {
      // console.log("test----------------------------------");
      this.$v.$touch();
      let payload;
      if (!this.$v.foldername.$invalid) {
        this.createprogress = true;
        console.log(this.parentfolder);
        // if(this.parentfolder === "") {
        // var payload = {
        //   folder_name: this.foldername,
        //   user_id: "5555"
        // }

        // }else{
        console.log("this.datahashtag", this.datahashtag);
        // for(let i=0; i < this.datahashtag.lenght; i++){
        //   this.listhashtag.push(this.datahashtag[i])
        // }
        // console.log("this.listhashtag",this.listhashtag);
        let allowCreateFolder = this.fn_checkSpecialChar();
        if (allowCreateFolder) {
          let payloadcheck = {
            folder_id: this.parentfolder,
            data_name: this.foldername,
            data_type: "folder",
          }
          let statusduplicate;
          let authcheck = await gbfGenerate.generateToken();
          await this.axios
            .post(process.env.VUE_APP_SERVICE_UPLOAD_API + "/api/v1/check_duplicate_data", payloadcheck, { headers: { Authorization: authcheck.code } })
            .then((response) => {
              if (response.data.message === "duplicate foldername") {
                // ชื่อซ้ำ
                statusduplicate = "duplicate";
              } else if (response.data.message === "unique foldername") {
                // ชื่อไม่ซ้ำ
                statusduplicate = "unique";
              } else {
                statusduplicate = "denied";
              }
            })
            .catch((error) => {
              console.log("error", error);
              statusduplicate = "denied";
            });
          if (statusduplicate === "unique") {
            // ยิงapi
            if (!this.payloadfolder.folder_name) {
              payload = {
                folder_name: this.foldername,
                user_id: this.dataUsername,
                id: this.parentfolder,
                account_id: this.dataAccountId,
                department_id: this.departmentid,
                hashtag: this.datahashtag,
                folder_duplicate: this.fileduplicate,
                // department_id: this.dataDepartmentAccessId
              };
            } else {
              payload = this.payloadfolder;
              payload.folder_duplicate = this.fileduplicate;
            }
            let url;
            if (this.$route.name === "directorysharefile") {
              url =
                process.env.VUE_APP_SERVICE_UPLOAD_FOLDER +
                "/api/insert_folder_share";
            } else {
              url =
                process.env.VUE_APP_SERVICE_UPLOAD_FOLDER +
                "/api/v2/insert_folder";
            }
            let auth = await gbfGenerate.generateToken();
            await this.axios
              .post(url, payload, { headers: { Authorization: auth.code } })
              .then((response) => {
                if (response.data.status === "OK") {
                  Toast.fire({
                    icon: "success",
                    title: this.$t("uploadfolder.createsucess"),
                  });
                  this.cleardata();
                  this.$emit("closeandreload");
                  this.listhashtag = [];
                  this.checkhashtag = false;
                  //console.log("test3333333----------------------------------",response);
                } else {
                  Toast.fire({
                    icon: "error",
                    title: this.$t("uploadfolder.cannotcreate"),
                  });
                }
                this.createprogress = false;
              })
              .catch((error) => {
                console.log(error.response);
                Toast.fire({
                  icon: "error",
                  title: this.$t("uploadfolder.cannotcreate"),
                });
                this.createprogress = false;
              });
          } else if (statusduplicate === "duplicate") {
            Toast.fire({
              icon: "error",
              title: this.$t("uploadfolder.nameduplicate"),
            });
            this.createprogress = false;
          } else {
            Toast.fire({
              icon: "error",
              title: this.$t("uploadfolder.cannotcreate"),
            });
            this.createprogress = false;
          }
        } else {
          // แจ้งerror
          console.log("error createfolder", allowCreateFolder);
        }
      }
    },
    cleardata() {
      this.$v.$reset();
      this.filename = "";
      this.createprogress = false;
      this.payloadfolder = {};
    },
  },
};
</script>
<style>
.v-input.textFieldClass input {
  font-size: 14px;
}
.v-text-field.textFieldClass .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
.v-input.hastaghClass input {
  font-size: 14px;
}
.v-text-field.hastaghClass .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
.v-input.hastaghClass input {
  font-size: 14px;
  max-height: 90px;
  padding-bottom: 11px;
  padding-top: 11px;
}
</style>